import { graphql, useStaticQuery } from 'gatsby'

const useLatestPost = resource => {
  const {
    allMdx: { posts },
  } = useStaticQuery(graphql`
    query {
      allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
        posts: nodes {
          ...postPreviewFragment
        }
      }
    }
  `)

  return posts.filter(({ frontmatter }) => frontmatter.resource === resource)[0]
}

export default useLatestPost
